<template>
	<div id="mainleft">
		<div class="logo">
			{{sysytemnamec}}
		</div>
		<!--background-color="#232f74"-->
		<el-menu router background-color="#232f74" text-color="#bababc" active-text-color="#fff" :collapse="this.$store.state.Collapse" :default-active="currentPath" >
			<el-submenu v-for="menu in menuData" :index="menu.moduleUrl" v-if="menu.childMenuList.length>0">
				<template slot="title">
					<i :class="menu.moduleIcon"></i>
					<span slot="title">{{menu.moduleName}}</span>
				</template>
				<el-menu-item-group >
					<el-menu-item v-for="childmenu in menu.childMenuList" :index="childmenu.moduleUrl" >{{childmenu.moduleName}}</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
		</el-menu>
	</div>
</template>
<script>
	export default {
		name: 'main_left',
		data:function(){
			return{
				currentPath:this.$route.path,
				sysytemname:"上海兴驰媒体广告牌系统",
				menuData:[],
			}
		},
		methods:{
			initdata(){
				var Vuethis=this;
				this.$hrraxios.get(this.$api.system.moduleByUser)
				.then((response)=>{
					var data=response.data;
					if(data.Success==true)
					{
						Vuethis.menuData=data.Data;
					}else{
						Vuethis.$message({message:redata.Prompt,type:"error"});
					}
				})
				.catch((error)=>{
					console.log(error);
				})
				//默认路由处理
				var pathArr=this.currentPath.split('/');
				var regurl=/^[a-zA-Z\/]*\/(add|view|edit)\/[0-9]*$/;
				if(regurl.test(this.currentPath)==true)
				{
					this.currentPath="/"+pathArr[1]+"/"+pathArr[2]
				}
			}
		},
		created:function(){
			this.initdata();
		},
		computed:{
			sysytemnamec:function(){
				var restr="";
				if(!this.$store.state.Collapse){
					restr=this.sysytemname;
				}else{
					restr="上";
				}

				if(this.$store.state.userName.substring(0,7)=="bjmetro")//特殊处理，北京用户修改公司抬头
					restr="北京地铁通成";
				return restr;
			}
		}
	};
</script>
<style>
.el-menu{border-right:0 solid #20222a!important;}
.el-menu--popup{background-color: #1e3f6c!important;}
</style>
